import React from 'react';

import { FormControlLabel, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

import { Lens } from '@material-ui/icons';
import file from '../../../assets/excelFile.svg'

import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';


interface PatternProps {
  pattern: any;
  intvl: number;
  handleChange: (type: string, event: any) => void;
  handleExport: (type: string) => void;
};


const Pattern = (props: PatternProps) => {
  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.flexWrap}`}>
        <h5 className={styles.heading}>Drop Off / Pick Up Patterns</h5>
        <RadioGroup
          row
          aria-label="Interval"
          name="Interval"
          className={`${styles.tcRadioGroup}`}>
          <small className={`${commonStyles.pr2}`}>Interval:</small>
          <FormControlLabel
            checked={props.intvl == 1 ? true : false}
            onClick={() => {
              props.handleChange('intvl', 1);
            }}
            control={
              <Radio
                value={1}
                color="primary"
                size="small"
              />
            }
            label="1 Hr"
            className={styles.carrierRadio}
          />
          <FormControlLabel
            checked={props.intvl == 2 ? true : false}
            onClick={() => {
              props.handleChange('intvl', 2);
            }}
            control={
              <Radio
                value={2}
                color="primary"
                size="small"
              />
            }
            label="2 Hr"
            className={styles.carrierRadio}
          />
          <FormControlLabel
            checked={props.intvl == 4 ? true : false}
            onClick={() => {
              props.handleChange('intvl', 4);
            }}
            control={
              <Radio
                value={4}
                color="primary"
                size="small"
              />
            }
            label="4 Hr"
            className={styles.carrierRadio}
          />
          <FormControlLabel
            checked={props.intvl == 6 ? true : false}
            onClick={() => {
              props.handleChange('intvl', 6);
            }}
            control={
              <Radio
                value={6}
                color="primary"
                size="small"
              />
            }
            label="6 Hr"
            className={styles.carrierRadio}
          />
          <FormControlLabel
            checked={props.intvl == 8 ? true : false}
            onClick={() => {
              props.handleChange('intvl', 8);
            }}
            control={
              <Radio
                value={8}
                color="primary"
                size="small"
              />
            }
            label="8 Hr"
            className={styles.carrierRadio}
          />
        </RadioGroup>
        <div className={`${styles.fileImg}`}>
          <img src={file} alt="file" onClick={()=> props.handleExport('pattern')} />
        </div>
      </div>
      <div>
        <TableContainer className={commonStyles.mt4}>
          <Table className={styles.patternTable} aria-label="table">
            <TableHead className={styles.patternTableHead}>
              <TableRow>
                <TableCell align="center">
                  <span className={styles.tblLabel}><Lens htmlColor='var(--secondarygreen)' fontSize="small" />Drop Offs</span>
                  <span className={styles.tblLabel}><Lens color='primary' fontSize="small" />Pick Ups</span>
                </TableCell>
                <TableCell align="center"><p>MON</p></TableCell>
                <TableCell align="center"><p>TUE</p></TableCell>
                <TableCell align="center"><p>WED</p></TableCell>
                <TableCell align="center"><p>THU</p></TableCell>
                <TableCell align="center"><p>FRI</p></TableCell>
                <TableCell align="center"><p>SAT</p></TableCell>
                <TableCell align="center"><p>SUN</p></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.patternTableBody}>
              {props.pattern.map((p: any) => (
                <TableRow key={p.time}>
                  <TableCell component="th" scope="row">
                    <span>{p.time}</span>
                  </TableCell>
                  <TableCell align="center">
                    {p.mon.do != 0 && (<span className={`${styles.bubble} ${styles.greenBubble}`}>{p.mon.do} </span>)}
                    {p.mon.po != 0 && (<span className={`${styles.bubble} ${styles.blueBubble}`}>{p.mon.po} </span>)}
                  </TableCell>
                  <TableCell align="center">
                    {p.tue.do != 0 && (<span className={`${styles.bubble} ${styles.greenBubble}`}>{p.tue.do} </span>)}
                    {p.tue.po != 0 && (<span className={`${styles.bubble} ${styles.blueBubble}`}>{p.tue.po} </span>)}
                  </TableCell>
                  <TableCell align="center">
                    {p.wed.do != 0 && (<span className={`${styles.bubble} ${styles.greenBubble}`}>{p.wed.do} </span>)}
                    {p.wed.po != 0 && (<span className={`${styles.bubble} ${styles.blueBubble}`}>{p.wed.po} </span>)}
                  </TableCell>
                  <TableCell align="center">
                    {p.thu.do != 0 && (<span className={`${styles.bubble} ${styles.greenBubble}`}>{p.thu.do} </span>)}
                    {p.thu.po != 0 && (<span className={`${styles.bubble} ${styles.blueBubble}`}>{p.thu.po} </span>)}
                  </TableCell>
                  <TableCell align="center">
                    {p.fri.do != 0 && (<span className={`${styles.bubble} ${styles.greenBubble}`}>{p.fri.do} </span>)}
                    {p.fri.po != 0 && (<span className={`${styles.bubble} ${styles.blueBubble}`}>{p.fri.po} </span>)}
                  </TableCell>
                  <TableCell align="center">
                    {p.sat.do != 0 && (<span className={`${styles.bubble} ${styles.greenBubble}`}>{p.sat.do} </span>)}
                    {p.sat.po != 0 && (<span className={`${styles.bubble} ${styles.blueBubble}`}>{p.sat.po} </span>)}
                  </TableCell>
                  <TableCell align="center">
                    {p.sun.do != 0 && (<span className={`${styles.bubble} ${styles.greenBubble}`}>{p.sun.do} </span>)}
                    {p.sun.po != 0 && (<span className={`${styles.bubble} ${styles.blueBubble}`}>{p.sun.po} </span>)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default Pattern;